import {Types}           from "@Common/types";
import {entries, values} from "@Common/utils/objects";

import {makeEmptyResultRows} from "./common/utils";

type Entry<T>            = Types.Common.Utils.Objects.Entry<T>;
type ReportModuleFactory = Types.Xpresso.Account.Admin.Reporting.ActivityDashboard.ReportModuleFactory;
type ReportModuleTabRow  = Types.Xpresso.Account.Admin.Reporting.ActivityDashboard.ReportModuleTabResultRow;

const TITLES:{[key in keyof Types.Apis.Payloads.Next.Reporting.UserRegistrationReport.Response]: string} = {
    newAgentsThisMonth    : "New Users This Month",
    newAgentsThisYear     : "New Users This Year",
    totalRegisteredAgents : "Total Registered Users",
};

export const makeUserRegistrationModule:ReportModuleFactory = ({apis}) => ({
    name                : "userRegistrationReport",
    title               : "User Registration",
    load                : async ({idBranch, idRegion}) => {
        try {
            const apiResult = await apis.next.reporting.userRegistrationReport({idBranch, idRegion});
            return [entries(apiResult).map(mapResultEntryAsTabRow)];
        } catch (error) {
            console.error(error);
            return [makeEmptyResultRows({titles: values(TITLES)})];
        }
    },
    supportsBranchLevel : true,
});

const mapResultEntryAsTabRow = ([key, content]:Entry<Types.Apis.Payloads.Next.Reporting.UserRegistrationReport.Response>): ReportModuleTabRow => {
    return {content, title: TITLES[key]};
};

